import { DatePicker } from 'antd';
import Gap from '~/components/Gap';
import StyledInput from '~/components/StyledInput';
import Text from '~/components/Text';
import { toDayjs } from '~/utils/datetime';
import { IBaseSectionType } from './types';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const BasicSection = ({ setValue, formData }: IBaseSectionType) => {
  const isDesktop = useIsDesktop();

  return (
    <div>
      <Text size={isDesktop ? 'md' : 'ssmd'} className={isDesktop ? 'bold' : ''}>
        Basic Details
      </Text>
      <Gap t={isDesktop ? 32 : 16} />

      <div className="full-width spread">
        <div className="full-flex">
          <Text size="xs">
            Invoice Number <span className="danger">*</span>
          </Text>
          <Gap t={4} />
          <StyledInput
            value={formData.invoiceNumber}
            onChange={e => setValue({ invoiceNumber: e.target.value })}
            className={`${!formData.invoiceNumber && 'error-field'}`}
            placeholder="e.g. INV00001"
          />
        </div>

        <Gap r={20} />

        <div className="full-flex">
          <Text size="xs">
            Invoice Date <span className="danger">*</span>
          </Text>
          <Gap t={4} />
          <DatePicker
            value={toDayjs(formData.invoiceDate)}
            className={`customDateInput ${!formData.invoiceDate && 'error-field'}`}
            format="MM/DD/YYYY"
            onChange={(newVal: any) => {
              setValue({ invoiceDate: newVal });
            }}
          />
        </div>
      </div>

      <Gap t={16} />

      <div className="full-width spread">
        <div className="full-flex">
          <Text size="xs">PO Number</Text>
          <Gap t={4} />
          <StyledInput
            value={formData.poNumber}
            onChange={e => setValue({ poNumber: e.target.value })}
          />
        </div>

        <Gap r={20} />

        <div className="full-flex">
          <Text size="xs">
            Invoice Due Date <span className="danger">*</span>
          </Text>
          <Gap t={4} />
          <DatePicker
            className={`customDateInput ${!formData.dueDate && 'error-field'}`}
            value={toDayjs(formData.dueDate)}
            format="MM/DD/YYYY"
            onChange={(newVal: any) => {
              setValue({ dueDate: newVal });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicSection;
